// ─── EditModeGate ─────────────────────────────────────────────────────────────
// Makes a whole panel read-only unless the dashboard is in Edit Mode.
//
// Used for the Settings sub-pages (API, Streaming Method, Public Portal,
// Embedded Data Applet, RSS Feed) and the Live screens, where the client asked
// that no changes be possible until the user explicitly enters Edit Mode via
// Settings -> Edit Mode.
//
// Implemented with a native `<fieldset disabled>` rather than per-control
// `disabled` props or a pointer-events overlay, because:
//   * the browser disables EVERY descendant input/select/textarea/button for
//     free — including controls added to those panels later, which a
//     hand-maintained list would miss;
//   * disabled controls are also excluded from form submission and are not
//     focusable, so keyboard users can't reach them either;
//   * text stays selectable and the panel stays scrollable, so values such as
//     API keys can still be READ and copied — which a `pointer-events-none`
//     overlay would have blocked.
//
// This is a UI guard, not a security boundary: the server still enforces its
// own permission checks on every write.

export function EditModeGate({ editMode, children, label = 'These settings' }) {
  if (editMode) return children

  return (
    <div className="w-full">
      {/* Match the panel card's width (max-w-xl) and centre it (mx-auto) so the
          notice sits directly above the centred card as one tidy column, rather
          than as a full-width bar beside a centred card. */}
      <div className="mb-3 px-4 py-2.5 bg-[#F1F2F4] border border-gray-200 rounded text-sm text-[#4D4D4D] w-full max-w-xl mx-auto">
        {label} are read-only. Choose <strong>Settings &rarr; Edit Mode</strong> to make changes.
      </div>
      {/* border-0/p-0/m-0/min-w-0 strip the fieldset's default chrome so the
          layout is identical to rendering the panel on its own. Kept as a plain
          block: the panel card centers itself with mx-auto (a flex container here
          would fight the card's `self-start`, which becomes a LEFT pin on the
          horizontal cross-axis in a flex column). */}
      <fieldset disabled className="border-0 p-0 m-0 min-w-0 w-full opacity-70">
        {children}
      </fieldset>
    </div>
  )
}
